import ExcelJS from 'exceljs';

export const ExportHelper = {
  prepareXslFile: async (sheetName, headers, data, language) => {
    const workbook = new ExcelJS.Workbook();

    const worksheet = workbook.addWorksheet(sheetName, {
      properties: {
        defaultColWidth: 15,
      },
      pageSetup: {
        horizontalCentered: true,
        verticalCentered: true,
      },
    });

    if (language === 'ar') worksheet.views = [{ rightToLeft: true }];

    const maxColumnWidths = new Array(headers.length).fill(0);

    worksheet.columns = headers.map((header, idx) => {
      const columnData = data.map(row => row[idx]);
      const headerWidth = header.length;
      const dataWidth = Math.max(...columnData.map(cell => cell?.toString().length));
      const maxColumnWidth = Math.max(headerWidth, dataWidth);
      maxColumnWidths[idx] = maxColumnWidth;
      return { header, key: `col${idx + 1}`, width: maxColumnWidth + 2 };
    });

    data.forEach(row => {
      worksheet.addRow(row.map(cell => cell?.toString()?.replace(/\n/g, '')));
    });

    worksheet.columns.forEach((column, idx) => {
      column.width = maxColumnWidths[idx] + 2;
    });

    const file = await workbook.xlsx.writeBuffer();

    return file;
  },
};
